export default [
    // 发布
    {
        path: '/fabu',
        name: 'Fabu',
        component: resolve =>require(['@/page/fabu'],resolve)
      },
    
];


// WEBPACK FOOTER //
// ./src/router/fabu.js